import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className='w-full h-full flex flex-col gap-6 p-6 md:p-10 text-gray-800 leading-relaxed'>
      <h1 className='text-2xl md:text-3xl font-semibold underline text-center'>
        Terms And Conditions
      </h1>

      <p>
        Welcome to <strong>Mukunda Silver Jewellers</strong>. By accessing or
        making a purchase on our website, you agree to the following Terms and
        Conditions. Please read them carefully.
      </p>

      <div className='flex flex-col gap-8'>
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>
            1. Order Processing & Delivery
          </h2>

          <ul className='ml-6 list-disc flex flex-col gap-2'>
            <li>
              All confirmed orders will be processed and shipped
              <strong> within 7 working days.</strong>
            </li>
            <li>
              Delivery timelines may vary depending on location, courier
              availability, and unforeseen delays.
            </li>
            <li>
              Customers will receive shipment details once the order is
              dispatched.
            </li>
          </ul>
        </div>
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>
            2. Return & Exchange Policy
          </h2>

          <h3 className='font-semibold text-md mt-4'>2.1 No Returns</h3>
          <ul className='ml-6 list-disc mt-2'>
            <li>
              We do not accept returns for any products purchased online or
              in-store.
            </li>
          </ul>

          <h3 className='font-semibold text-md mt-6'>2.2 Exchange Policy</h3>

          <ol className='ml-6 list-decimal flex flex-col gap-3 mt-2'>
            <li>
              Customers can avail
              <strong>
                {' '}
                100% exchange value on gold, diamonds, and silver jewellery
                within 7 days{' '}
              </strong>
              from the date of delivery or purchase.
            </li>

            <li>
              If the exchange request is made after 7 days, only 70% exchange
              value will be provided.
            </li>

            <li>For any exchange request:</li>

            <ul className='ml-4 lg:ml-10 list-disc flex flex-col gap-2'>
              <li>
                A <strong>proper opening/unboxing video</strong> is mandatory
                for online orders.
              </li>

              <ul className='ml-6 list-[circle] flex flex-col gap-2'>
                <li>
                  The video must be continuous, unedited, and show the sealed
                  package from all angles.
                </li>
                <li>
                  Any tampering or unclear video will void eligibility for
                  exchange.
                </li>
              </ul>

              <li>
                The customer must{' '}
                <strong>visit any Mukunda Silver Jewellers store</strong> within
                the eligible period (7 days for 100% value, after 7 days for 70%
                value).
              </li>
            </ul>

            <li>Products must be:</li>

            <ul className='ml-10 list-disc flex flex-col gap-1'>
              <li>Unused and in original condition</li>
              <li>Accompanied by the original invoice</li>
              <li>Intact with all accessories, certificates, and packaging</li>
            </ul>

            <li>Items once exchanged cannot be exchanged again.</li>

            <li>
              Final approval of exchange is at the sole discretion of Mukunda
              Silver Jewellers after product inspection.
            </li>
          </ol>
        </div>
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>3. Pricing & Payments</h2>

          <ol className='ml-6 list-decimal flex flex-col gap-2'>
            <li>
              All prices listed on the website are final and inclusive/exclusive
              of taxes as applicable.
            </li>
            <li>
              Mukunda Silver Jewellers reserves the right to modify prices at
              any time without prior notice.
            </li>
            <li>
              Orders are considered confirmed only after successful payment.
            </li>
          </ol>
        </div>
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>
            4. Product Images & Descriptions
          </h2>

          <ol className='ml-6 list-decimal flex flex-col gap-2'>
            <li>
              Product images on the website are for representation and may
              slightly vary due to lighting, screen resolution, or handmade
              variations.
            </li>
            <li>
              We strive for accuracy in product descriptions; however, minor
              differences may occur.
            </li>
          </ol>
        </div>
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>5. Shipping Issues</h2>

          <ol className='ml-6 list-disc flex flex-col gap-2'>
            <li>
              In case of wrong delivery, damaged products, or missing items, the
              customer must report the issue <strong>within 24 hours</strong> of
              delivery along with the mandatory opening video.
            </li>
            <li>Claims without an opening video will not be accepted.</li>
          </ol>
        </div>{' '}
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>6. Cancellation Policy </h2>

          <ol className='ml-6 list-disc flex flex-col gap-2'>
            <li>
              Orders cannot be cancelled once they are confirmed and processed.
            </li>
            <li>
              Cancellation (if accepted due to any exceptional reason) is at the
              sole discretion of Mukunda Silver Jewellers.{' '}
            </li>
          </ol>
        </div>{' '}
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>
            7. Store Visits for Exchange{' '}
          </h2>

          <ol className='ml-6 list-disc flex flex-col gap-2'>
            <li>
              Exchange will be{' '}
              <strong>processed only at Mukunda Jewellery stores.</strong>
            </li>
            <li>
              Customers must bring the original product, invoice, and opening
              video for verification.
            </li>
          </ol>
        </div>{' '}
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>8. Liability</h2>

          <ol className='ml-6 list-disc flex flex-col gap-2'>
            <li>
              Mukunda Silver Jewellers is not responsible for delays caused by
              logistics partners or natural disruptions.
            </li>
            <li>
              We are not liable for any damage caused after product delivery
              unless proven via the mandatory unboxing video.{' '}
            </li>
          </ol>
        </div>{' '}
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>9. Policy Updates </h2>

          <ol className='ml-6 flex flex-col gap-2'>
            <li>
              Mukunda Silver Jewellers reserves the right to modify these Terms
              & Conditions at any time. Updated policies will be published on
              this page.
            </li>
           
          </ol>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
